export default __webpack_public_path__ + "static/4-7c68184c982ff4df057be73ce72b02af.jpg";